module.exports = __webpack_public_path__ + "img/ESCUT_ACTUAL_v2.e589a6aa.png";